export default __webpack_public_path__ + "static/media/noypi-oyat-icons-mobile.eca76abf.svg";